import React, { useState } from 'react';
import { TopBar } from './components/AmplifierControl/Index';
import { AmplifierI18nProvider } from './i18n/amplifier/AmplifierI18nProvider';

const TestPage: React.FC = () => {
  const [isConnected, setIsConnected] = useState(true);
  const [isMcuConnected, setIsMcuConnected] = useState(true);

  const handleAntennaChange = (mode: 'manual' | 'auto') => {
    console.log('天线模式改变:', mode);
  };

  const handleTriggerModeChange = (mode: 'PTT1' | 'PP2' | '输入功率触发') => {
    console.log('触发模式改变:', mode);
  };

  return (
    <AmplifierI18nProvider>
      <div style={{ height: '100vh', backgroundColor: 'var(--color-bg-secondary)' }}>
        <TopBar
          isConnected={isConnected}
          isMcuConnected={isMcuConnected}
          onAntennaChange={handleAntennaChange}
          onTriggerModeChange={handleTriggerModeChange}
        />
      </div>
    </AmplifierI18nProvider>
  );
};

export default TestPage;
